export default __webpack_public_path__ + "static/media/product.7ca57508.png";